import React from 'react'
import { GeoJSON } from 'react-leaflet'

export default function RegionOutlinesMA(props) {
  const { mapStyle, fillColors=[], geo="drought" } = props;
  const geodata = (geo === "drought" ? require('./geo/droughtR_geo.json') : geo);

  return (
    <GeoJSON
      data={geodata}
      style={(fo) => {return {...mapStyle, ...{fillColor:fillColors[fo.properties.DROUGHT_ZO] || "rgba(255, 255, 255, 0.5)"}}}}
    /> 
  )
}